import { humanize } from "../components/ui";

export function WorkblockSectionTitle({
  eyebrow,
  title,
  description,
  id
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  id?: string;
}) {
  return (
    <div className="apf-section-heading">
      <div>
        {eyebrow ? <p className="apf-section-heading__eyebrow">{eyebrow}</p> : null}
        <h2 id={id}>{title}</h2>
        {description ? <p>{description}</p> : null}
      </div>
    </div>
  );
}

export function WorkblockList(items: readonly string[], className = "apf-pattern-list") {
  return items.length
    ? <ul className={className}>{items.map((item) => <li key={item}>{item}</li>)}</ul>
    : <p>None declared.</p>;
}

export function WorkblockCodeValues({
  values,
  empty = "None declared"
}: {
  values: readonly string[];
  empty?: string;
}) {
  if (!values.length) return <span>{empty}</span>;
  return <span className="apf-field-chip-list">{values.map((value) => <code key={value}>{value}</code>)}</span>;
}

export function MappingOwnership({ ownershipMode, access }: { ownershipMode: string; access: string }) {
  return <>{humanize(ownershipMode)} · {humanize(access)}</>;
}
